<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->
<!-- eslint-disable vue/no-v-html -->

<template>
    <div class="sl-order-form__line sl-order-form__line-grouped" :class="{ 'sl-order-form__line--error': error }">
        <!-- Label -->
        <slot name="label" />

        <!-- Field Wrapper -->
        <div class="flex justify-center w-full">
            <radio-button
                :model-value="modelValue"
                :items="parameter.list_items"
                :nullable="!parameter.is_required"
                :tabindex="tabIndex"
                class="sl-order-form__field-wrapper lsn-form__radio-item-wrapper w-auto"
                style="width: auto;"
                @update:model-value="$emit('update:modelValue', $event)"
            />
        </div>

        <!-- Supplement -->
        <div v-if="supplement" class="sl-order-form__supplement-wrapper">
            <div class="sl-order-form__supplement">
                {{ supplement }}
            </div>
        </div>

        <!-- Note -->
        <div v-if="parameter.note" class="sl-order-form__note-wrapper">
            <div class="sl-order-form__note">
                {{ parameter.note }}
            </div>
        </div>

        <!-- Error -->
        <div v-if="error" class="sl-order-form__error-wrapper">
            <div class="sl-order-form__error">
                {{ error }}
            </div>
        </div>

        <!-- Splitter -->
        <slot name="splitter" />
    </div>
</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>
import AbstractGroupedField from './AbstractGroupedField.vue';
import RadioButton from '@/components/RadioButton.vue';

export default
{
    name: 'GroupedRadioButtonField',

    components:
    {
        RadioButton,
    },

    extends: AbstractGroupedField,

    emits: ['update:modelValue'],

    data()
    {
        return {
            isTouched: false,
        };
    },

    computed:
    {
        cIndex()
        {
            return this.parameter.list_items.findIndex(i => i.ovalue == this.modelValue);
        },
    },
};
</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style scoped>
@reference "#main.css";

.sl-order-form__line
{
    @apply pb-1;
}

.sl-order-form__supplement-wrapper
{
    @apply mt-2;
}
</style>
